import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Header = () => {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => {
      const newState = !prev;
      document.body.classList.toggle("mobile-nav-active", newState);
      return newState;
    });
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    document.body.classList.remove("mobile-nav-active");
  };

  return (
    <header id="header" className="header d-flex align-items-center fixed-top">
      <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
        <HashLink
          smooth
          to="/#hero"
          className="logo d-flex align-items-center"
          onClick={closeMobileMenu}
        >
          <h1 className="sitename">Zapibook</h1>
        </HashLink>

        <nav
          id="navmenu"
          className={`navmenu ${mobileMenuOpen ? "mobile-nav-active" : ""}`}
        >
          <ul>
            <li>
              <HashLink
                smooth
                to="/#hero"
                className="active"
                onClick={closeMobileMenu}
              >
                {t("navigation.home")}
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/#about" onClick={closeMobileMenu}>
                {t("navigation.about")}
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/#features" onClick={closeMobileMenu}>
                {t("navigation.features")}
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/#pricing" onClick={closeMobileMenu}>
                {t("navigation.pricing")}
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/#contact" onClick={closeMobileMenu}>
                {t("navigation.contact")}
              </HashLink>
            </li>
            <li style={{ marginBottom: "0.5rem", paddingLeft: "1.5rem" }}>
              <LanguageSwitcher />
            </li>
          </ul>
        </nav>

        <i
          className={`mobile-nav-toggle d-xl-none bi ${
            mobileMenuOpen ? "bi-x" : "bi-list"
          }`}
          onClick={toggleMobileMenu}
        ></i>
      </div>
    </header>
  );
};

export default Header;
